import React from 'react';
import { useLocation } from 'react-router-dom';
import './NotFound.css';

// Pagina 404: un PLC prova a parlare con il PC, ma il cavo è tranciato.
// Richiama il mio lavoro: collegare macchine industriali e software.
const MAX_PATH_CHARS = 36;
const ERROR_TEXT = 'ERR 404: nessun nodo risponde qui';

const NotFound: React.FC = () => {
  const { pathname } = useLocation();
  const shownPath = pathname.length > MAX_PATH_CHARS ? `${pathname.slice(0, MAX_PATH_CHARS)}…` : pathname;
  const request = `GET ${shownPath}`;

  return (
    <div className="not-found">
      <svg
        className="nf-scene"
        viewBox="0 0 520 170"
        role="img"
        aria-label="Un PLC e un computer collegati da un cavo tranciato: la connessione è interrotta"
      >
        {/* PLC */}
        <g>
          <rect x="18" y="38" width="118" height="92" rx="8" className="nf-box" />
          <rect x="28" y="48" width="98" height="14" rx="3" className="nf-plate" />
          <text x="77" y="59" textAnchor="middle" className="nf-plate-text">PLC</text>
          <circle cx="42" cy="82" r="5" className="nf-led nf-led--ok nf-led--d0" />
          <circle cx="62" cy="82" r="5" className="nf-led nf-led--ok nf-led--d1" />
          <circle cx="82" cy="82" r="5" className="nf-led nf-led--ok nf-led--d2" />
          <circle cx="102" cy="82" r="5" className="nf-led nf-led--err" />
          <rect x="30" y="100" width="94" height="6" rx="2" className="nf-slot" />
          <rect x="30" y="112" width="94" height="6" rx="2" className="nf-slot" />
        </g>

        {/* Cavo: metà sinistra collegata, metà destra penzolante */}
        <path d="M136 84 H236" className="nf-cable" />
        <path d="M290 84 H392" className="nf-cable nf-cable--dead" />
        <circle cx="236" cy="84" r="4" className="nf-copper" />
        <circle cx="290" cy="84" r="4" className="nf-copper" />

        {/* Pacchetti dati che si perdono sul punto di rottura */}
        <g className="nf-packets">
          <text x="140" y="79" className="nf-packet nf-packet--a">01</text>
          <text x="140" y="79" className="nf-packet nf-packet--b">10</text>
          <text x="140" y="79" className="nf-packet nf-packet--c">11</text>
        </g>

        {/* Scintille */}
        <path d="M241 84 l7 -11 l5 14 l7 -12 l5 9" className="nf-spark" />
        <path d="M241 84 l6 10 l6 -9 l8 11 l4 -8" className="nf-spark nf-spark--b" />

        {/* PC */}
        <g>
          <rect x="392" y="26" width="112" height="82" rx="8" className="nf-box" />
          <rect x="400" y="34" width="96" height="62" rx="4" className="nf-screen" />
          <text x="448" y="76" textAnchor="middle" className="nf-screen-text">404</text>
          <text x="448" y="50" textAnchor="middle" className="nf-screen-sub">no signal</text>
          <rect x="436" y="108" width="24" height="12" className="nf-plate" />
          <rect x="420" y="120" width="56" height="6" rx="3" className="nf-plate" />
        </g>

        <text x="262" y="60" textAnchor="middle" className="nf-question">?</text>
      </svg>

      <div className="nf-terminal" role="status">
        <div className="nf-line">
          <span className="nf-prompt">&gt;</span>
          <span className="nf-type nf-type--1" style={{ ['--chars' as string]: request.length }}>{request}</span>
        </div>
        <div className="nf-line nf-line--err">
          <span className="nf-prompt">!</span>
          <span className="nf-type nf-type--2" style={{ ['--chars' as string]: ERROR_TEXT.length }}>{ERROR_TEXT}</span>
          <span className="nf-cursor" aria-hidden="true" />
        </div>
      </div>

      <p className="not-found__message">
        Questa pagina non esiste, ma le macchine che ho collegato sì.
      </p>

      <div className="nf-actions">
        <a href="/" className="not-found__link">Torna alla home</a>
        <a href="/#projects" className="not-found__link not-found__link--ghost">Vedi i progetti</a>
      </div>
    </div>
  );
};

export default NotFound;
